import { Injectable } from "@angular/core";
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from "@angular/forms";

@Injectable({ providedIn: 'root' })
export class FormService {
  valider(formGroup: UntypedFormGroup | UntypedFormArray): boolean {
    formGroup.markAsDirty({ onlySelf: true });

    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);

      if (control instanceof UntypedFormControl) {
        control.markAsDirty({ onlySelf: true });
        control.updateValueAndValidity();
      } else if (control instanceof UntypedFormGroup || control instanceof UntypedFormArray) {
        control.markAsDirty({ onlySelf: true });
        control.updateValueAndValidity();
        this.valider(control);
      }
    });

    return formGroup.valid;
  }
}
